import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command"

export function MultiSearchableSelect({
  values = [],
  onValuesChange,
  options = [],
  placeholder = "Todos",
  searchPlaceholder = "Buscar...",
  emptyText = "Sin resultados.",
  className,
  triggerClassName,
  "data-testid": testId,
}) {
  const [open, setOpen] = React.useState(false)

  const allOptions = options.map(o => (typeof o === "string" ? { value: o, label: o } : o))

  const selectedLabel = values.length === 0
    ? placeholder
    : values.length === 1
      ? (allOptions.find(o => o.value === values[0])?.label || values[0])
      : `${values.length} seleccionados`

  const toggle = (val) => {
    const next = values.includes(val) ? values.filter(v => v !== val) : [...values, val]
    onValuesChange(next)
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          data-testid={testId}
          className={cn(
            "w-full justify-between font-normal h-10 px-3 text-sm",
            values.length === 0 ? "text-muted-foreground" : "",
            triggerClassName
          )}
        >
          <span className="truncate">{selectedLabel}</span>
          <ChevronsUpDown className="ml-1 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className={cn("p-0 w-[--radix-popover-trigger-width]", className)} align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} />
          <CommandList>
            <CommandEmpty>{emptyText}</CommandEmpty>
            <CommandGroup>
              <CommandItem
                key="__ALL__"
                value={placeholder}
                onSelect={() => onValuesChange([])}
                data-testid={testId ? `${testId}-all` : undefined}
              >
                <Check className={cn("mr-2 h-4 w-4", values.length === 0 ? "opacity-100" : "opacity-0")} />
                {placeholder}
              </CommandItem>
              {allOptions.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.label}
                  onSelect={() => toggle(option.value)}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      values.includes(option.value) ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {option.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
